export default __webpack_public_path__ + "static/media/Gonies_Paletopoiisis.07b1108e.jpg";